module.exports = __webpack_public_path__ + "d41885b15944bc1db96bf79e38d4210d.svg";